<template>
  <v-card>
    <v-card>
      <v-card-text>
        <v-card-title>
          <v-flex xs2 class="mr-4">
            <v-btn
              round
              color="success"
              class="white--text mb-3"
              @click="createNewMaterial"
            >
              <v-icon dark>add</v-icon>
              Crear nuevo contrato
            </v-btn>
          </v-flex>

          
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar..."
            single-line
            hide-details
            @change="getAllPrecios()"
            @keypress="getAllPrecios()"
            @keyup="getAllPrecios()"
            clearable
          ></v-text-field>
        </v-card-title>
      </v-card-text>
    </v-card>
    <br />
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <confirm ref="confirm"></confirm>
    <v-dialog
      v-model="dialogUpload"
      max-width="1100px"
      @input="(v) => v || verCargaFactores()"
    >
      <v-card>
        <v-card-title>
          <h3 class="mb-0">Cargar masiva Precios</h3>
        </v-card-title>
        <v-card-text>
          <v-flex sm10>
            <v-btn
              round
              color="success"
              class="white--text mb-3"
              @click="getPreciosExcel"
            >
              <v-icon>attach_file</v-icon>
              Descargar Archivo Carga</v-btn
            >
          </v-flex>
          <v-flex sm10>
            <v-text-field
              label="Adjuntar Archivo"
              @click="pickFile"
              v-model="archivo"
              prepend-icon="attach_file"
              :readonly="true"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image"
              @change="onFilePicked"
              id="filePDF"
            />
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="success" @click="guardarFactoresExcel()" dark>
            <v-icon class="mr-1">done_all</v-icon>Guardar
          </v-btn>
          <v-btn color="grey" @click="verCargaFactores" dark>
            <v-icon class="mr-1">cancel</v-icon>Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMateriales" persistent max-width="1100px">
      <v-card>
        <v-card-title>
          <span
            class="title"
            v-if="detalleItem.id > 0 && detalleItem.rutCliente"
            >Detalle Contrato : {{ detalleItem.codigoContrato }} - Cliente
            {{ detalleItem.rutCliente }}</span
          >
          <span
            class="title"
            v-else-if="
              detalleItem.id > 0 && !detalleItem.rutCliente
            "
            >Detalle Contrato : {{ detalleItem.codigoContrato }}</span
          >
          <span class="title" v-else>Nuevo Contrato</span>
        </v-card-title>
        <!-- /*
                  id: 0,     
      rutCliente: null,
      codigoContrato: null,
      codigoLicitacion: null,
      fechaInicio: null,
      fechaFin: null,    
      estadoVigencia: true,
      menufechaInicio: false,
      menufechaFin: false,

    */ -->
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md3 v-if="detalleItem.id > 0">
                <v-text-field
                  label="Id"
                  v-model="detalleItem.id"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md9 v-if="detalleItem.id > 0">&nbsp;</v-flex> 
               <v-flex xs12 sm6 md3>
                <v-text-field
                  label="Código Contrato"
                  v-model="detalleItem.codigoContrato" :rules="[rules.required]"
                ></v-text-field>
               
              </v-flex>
                <v-flex xs12 sm6 md3>
                <v-text-field
                  label="Código Licitación"
                  v-model="detalleItem.codigoLicitacion" :rules="[rules.required]"
                ></v-text-field>
               
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  label="Rut Cliente"
                  v-model="detalleItem.rutCliente"  @keyup="formatRut" :rules="[rules.rut]"
                ></v-text-field>
               
              </v-flex>
                <v-flex xs12 sm6 md3>
                &nbsp;
               
              </v-flex>
               <v-flex xs12 sm6 md3>
               <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="detalleItem.menufechaInicio"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Inicio"
                      prepend-icon="event"
                      v-model="dateFormatedInicio"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="detalleItem.fechaInicio"
                    ></v-date-picker>
                  </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md3>
               <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    v-model="detalleItem.menufechaFin"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Fin"
                      prepend-icon="event"
                      v-model="dateFormatedFin"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      locale="es-cl"
                      no-title
                      v-model="detalleItem.fechaFin"
                    ></v-date-picker>
                  </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="detalleItem.id > 0">
                <v-checkbox
                  v-model="detalleItem.estadoVigencia"
                  label="Vigente?"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 md3 v-else>
                &nbsp;
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="detalleItem.id > 0">
                <v-btn color="success mt-4" @click="saveDetalleItem()" dark>
                  <v-icon class="mr-1">add</v-icon>Agregar Detalle
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="saveDetalleItem()" dark>
            <v-icon class="mr-1">done_all</v-icon>Guardar
          </v-btn>
          <v-btn color="grey" @click="cleanDetalle" dark>
            <v-icon class="mr-1">cancel</v-icon>Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text>
      <v-data-table
        :items="detalleFiltroItems"
        :headers="headers"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :loading="loading"
        content-tag="v-layout"
        row
        wrap
        no-results-text
        no-data-text
        rows-per-page-text="Registros por página"
      >
        <v-progress-linear
          v-slot:progress
          color="blue"
          indeterminate
        ></v-progress-linear>
        <template v-slot:items="props">
          <!-- 

      id: 0,     
      rutCliente: null,
      codigoContrato: null,
      codigoLicitacion: null,
      fechaInicio: null,
      fechaFin: null,    
      estadoVigencia: true,
      menufechaInicio: false,
      menufechaFin: false,

          -->
          <td>{{ props.item.id }}</td>
          <td>
            {{ props.item.codigoContrato }}
          </td>

          <td>{{ props.item.codigoLicitacion }}</td>
          <td>{{ props.item.rutCliente }}</td>        
          <td>{{ getHumanDate(props.item.fechaInicio) }}</td>
          <td>{{ getHumanDate(props.item.fechaFin) }}</td>
          <td>
            <v-btn
              :color="calculaStatus(props.item.estadoVigencia)"
              small
              dark
              @click="desactivar(props.item)"
            >
              {{ showVigencia(props.item.estadoVigencia) }}
            </v-btn>
          </td>

          <td class="right layout">
            <v-btn
              color="primary"
              fab
              small
              dark
              @click="verDetalle(props.item)"
              slot="activator"
              class="pr-0 mr-0"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="pageText" slot-scope="props"
          >Registros {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}</template
        >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import OrdenCompraService from "@/services/OrdenCompraService";
import FileService from "@/services/FileService";
import Loader from "@/components/Loader";
import moment from "moment";
//import FiltrosService from "@/services/FiltrosService";
import VWidget from "@/components/VWidget";
import AppEvents from "@/eventBus";

export default {
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: "",
    },
    rules: {
      required: (value) => !!value || "campo obligatorio.",
      largoNombre: (v) => !v || v.length <= 50 || "Max 50 carácteres",
      largo: (v) => !v || v.length <= 300 || "Max 300 carácteres",
      largoUM: (v) => !v || v.length <= 30 || "Max 30 carácteres",
      filtro: (value) => {
        //const pattern = /[^a-zA-Z0-9\s\\*\(\)\|]+/;
        const pattern = /[a-zA-Z0-9*()"\s]$/; ///[a-zA-Z0-9!@#$%^*_|]/;
        if (!value || value.trim().length > 0) {
          return pattern.test(value) || "filtro con formato incorrecto.";
        }
      },
       producto: (value) => {
        //const pattern = /[^a-zA-Z0-9\s\\*\(\)\|]+/;
         
         return value.id || "debe seleccionar producto válido.";
      },
      rut: (value) => {
        if(value)
        {
            let valid = false;
                let rut = value
                    if (typeof rut !== 'string') {
                        return false
                    }
                    rut = typeof value === 'string' ? value.replace(/[^0-9kK]+/g, '').toLowerCase() : ''
                    var rutDigits = parseInt(rut.slice(0, -1), 10)
                    var m = 0
                    var s = 1
                    while (rutDigits > 0) {
                        s = (s + rutDigits % 10 * (9 - m++ % 6)) % 11
                        rutDigits = Math.floor(rutDigits / 10)
                    }
                    var checkDigit = (s > 0) ? String((s - 1)) : 'k'
                    if (checkDigit === rut.slice(-1)) {
                        valid = false
                    } else {
                        valid = true
                    }
            
              return !valid || "rut inválido"
         }
       
        
        }
    },
    dialogMateriales: false,
    productosBusqueda: [],
    dialogUpload: false,
    isLoading: false,
    showRutInvalido : false,
    archivo: "",
    /*
    
             x.Id, x.RutCliente, x.CodigoContrato, x.CodigoLicitacion, x.FechaInicio, x.FechaFin, x.EstadoVigencia
      
    */
    detalleItemDefault: {
      id: 0,     
      rutCliente: null,
      codigoContrato: null,
      codigoLicitacion: null,
      fechaInicio: null,
      fechaFin: null,    
      estadoVigencia: true,
      menufechaInicio: false,
      menufechaFin: false,
    },
    detalleItem: {
      id: 0,     
      rutCliente: null,
      codigoContrato: null,
      codigoLicitacion: null,
      fechaInicio: null,
      fechaFin: null,    
      estadoVigencia: true,
      menufechaInicio: false,
      menufechaFin: false,
    },
    dialog: false,
    resolve: null,
    search: "",
    reject: null,
    message: null,
    title: null,
    loading: false,
    rowsPerPageItems: [5, 10, 20],
    pagination: {
      page: 1,
      rowsPerPage: 5,
      sortBy: "id",
      descending: true,
    },
    totalItems: 0,
    options: {
      color: "primary",
      width: 290,
      titulo: "",
      filtro: 0,
      cliente: 0,
    },
    /*
                   id: 0,     
      rutCliente: null,
      codigoContrato: null,
      codigoLicitacion: null,
      fechaInicio: null,
      fechaFin: null,    
      estadoVigencia: true,
      menufechaInicio: false,
      menufechaFin: false,

    */
    headers: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "id",
        width: "5%",
      },
      {
        text: "Código Contrato",
        align: "left",
        sortable: true,
        value: "codigoContrato",
       
      },
      {
        text: "Código Licitacion",
        align: "left",
        sortable: true,
       
        value: "codigoLicitacion",
      },
      {
        text: "Rut Cliente",
        align: "left",
        sortable: true,
        value: "rutCliente",
      },      
      {
        text: "Fecha Inicio",
        align: "left",
        sortable: true,
        value: "fechaInicio",
      },
      {
        text: "Fecha Fin",
        align: "left",
        sortable: true,
        value: "fechaFin",
      },
      {
        text: "Estado Vigencia",
        align: "left",
        sortable: true,
        value: "estadoVigencia",
      },
    ],
  }),

  methods: {
     formatRut () {
                let clearRut = typeof this.detalleItem.rutCliente === 'string' ? this.detalleItem.rutCliente.replace(/[^0-9kK]+/g, '').toLowerCase() : '' // limpiamos la variable rut
                if (clearRut.length <= 1) {
                    return false
                }
                var result = clearRut.slice(-4, -1) + '-' + clearRut.substr(clearRut.length - 1)
                for (var i = 4; i < clearRut.length; i += 3) {
                    result = clearRut.slice(-3 - i, -i) + '.' + result
                }
                this.detalleItem.rutCliente = result
                let rut = this.detalleItem.rutCliente
                if (typeof rut !== 'string') {
                    return false
                }
                rut = typeof this.detalleItem.rutCliente === 'string' ? this.detalleItem.rutCliente.replace(/[^0-9kK]+/g, '').toLowerCase() : ''
                var rutDigits = parseInt(rut.slice(0, -1), 10)
                var m = 0
                var s = 1
                while (rutDigits > 0) {
                    s = (s + rutDigits % 10 * (9 - m++ % 6)) % 11
                    rutDigits = Math.floor(rutDigits / 10)
                }
                var checkDigit = (s > 0) ? String((s - 1)) : 'k'
                if (checkDigit === rut.slice(-1)) {
                    this.showRutInvalido = false
                } else {
                    this.showRutInvalido = true
                }
            },
    getHumanDate(date) {
      if (!date) return "";
      if (date === "0001-01-01") return "";
      return moment(date).format("DD-MM-YYYY");
    },
    async getPreciosExcel() {
      this.loading = true;
      const response = await OrdenCompraService.getPreciosExcel();
      this.loading = false;
    },
    async getAllPrecios() {
      let paging = this.pagination;
      let sort = paging.sortBy === null ? "id" : paging.sortBy;
      let direction =
        paging.descending === null
          ? " desc"
          : paging.descending === true
          ? " desc"
          : " asc";
      sort = sort + direction;
      let paginacion =
        "sort=" +
        sort +
        "&page=" +
        paging.page +
        "&pageSize=" +
        paging.rowsPerPage;

      debugger;
      this.loading = true;
      var busqueda = this.search == null ? "" : this.search;
      const response = await OrdenCompraService.getAllContratos(
        paginacion,
        busqueda
      )
        .then((r) => {
          debugger;
          this.detalleFiltroItems = r.data.data;
          this.totalItems = r.data.totalCount;
          this.loading = false;
        })
        .catch((r) => {
          console.log(r.response);
        });
    },
    guardarFactoresExcel() {
      let input = document.getElementById("filePDF");
      let files = input.files;
      var FileServiceTMp = new FileService();

      if (files != null && files.length > 0) {
        FileServiceTMp.get(files[0])
          .then((file) => {
            this.loading = true;
            debugger;
            OrdenCompraService.createPreciosExcel({
              File: file,
              Model: "FileUpload",
            })
              .then((r2) => {
                this.loading = false;
                this.verCargaFactores();
                this.getAllPrecios();
                this.snackbar = {
                  show: true,
                  color: "green",
                  text: "Precios actualizados con éxito",
                  timeout: 3000,
                };
              })
              .catch((r2) => {
                debugger;
                this.loading = false;
                console.log(r2.response.data);
                this.snackbar = {
                  show: true,
                  color: "red",
                  text: r2.response.data,
                  timeout: 3000,
                };
              });
          })
          .catch((r1) => {
            console.log(r1);
          });
      }
    },
    verCargaFactores() {
      this.removeFile();
      this.dialogUpload = !this.dialogUpload;
    },
    removeFile() {
      document.getElementById("filePDF").value = "";
      this.archivo = "";
    },
    openFileDialog() {
      document.getElementById("file-upload").click();
    },
    onFileChange(e) {
      let self = this;
      let files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          self.formData.append("file", files[i], files[i].name);
        }
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      debugger;
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.archivo = files[0].name;
        if (this.archivo.lastIndexOf(".") <= 0) {
          return;
        }
      } else {
        this.archivo = "";
      }
    },
    showVigencia(vigencia) {
      return vigencia === true ? "Vigente" : "No Vigente";
    },
    calculaStatus(vigencia) {
      return vigencia === true ? "green" : "red";
    },
    irLicitacion(item) {
      this.$router.push({
        name: "LicitacionDetalle",
        params: { codigo: item.codigoExterno },
      });
    },

    async desactivar(item) {
      this.$refs.confirm
        .open(
          "Desactivar precio ",
          "Desea " +
            (!item.estadoVigencia === true ? "Activar" : "Desactivar") +
            " el precio ?",
          {
            color: !item.estadoVigencia === true ? "green" : "red",
            width: 500,
          }
        )
        .then((confirm) => {
          if (confirm) {
            this.loading = true;
          
            let precioDto = {
              id: item.id,
              idMaterial: item.idMaterial,
              codigoArticulo: null,
              codigoArticuloIntegracion: null,
              codigoDescripcionArticulo: null,
              rutCliente: item.rutCliente,
              precioMin: item.precioMin,
              precioMax: item.precioMax,
              precioLista: item.precioLista,
              fechaVigenciaDesde: item.fechaVigenciaDesde,
              fechaVigenciaHasta: item.fechaVigenciaHasta,
              estadoVigencia: !item.estadoVigencia,          
            };
            const response = OrdenCompraService.updatePrecio(precioDto)
              .then((r) => {
                this.loading = false;
                this.getAllPrecios();
                this.snackbar = {
                  show: true,
                  color: "green",
                  text: "Precio actualizado con éxito.",
                };
              })
              .catch((r) => {
                this.loading = false;
                console.log(r.response);
              });
          }
        });
    },
    async saveDetalleItem() {
      this.$refs.confirm
        .open(
          (!this.detalleItem.id === 0 ? "Crear " : "Actualizar ") +
            "Precio " ,
          "Desea " +
            (this.detalleItem.id === 0 ? "Crear" : "Actualizar") +
            " el precio ?",
          {
            color: "green",
            width: 500,
          }
        )
        .then((confirm) => {
          if (confirm) {
            this.loading = true;
            let precioDto = {
              id: this.detalleItem.id,
              idMaterial: this.detalleItem.codigoArticuloIntegracion.id,
              codigoArticulo: null,
              codigoArticuloIntegracion: null,
              codigoDescripcionArticulo: null,
              rutCliente: this.detalleItem.rutCliente,
              precioMin: this.detalleItem.precioMin,
              precioMax: this.detalleItem.precioMax,
              precioLista: this.detalleItem.precioLista,
              fechaVigenciaDesde: this.detalleItem.fechaVigenciaDesde,
              fechaVigenciaHasta: this.detalleItem.fechaVigenciaHasta,
              estadoVigencia: this.detalleItem.id === 0 ? true: this.detalleItem.estadoVigencia,          
            };
            if (this.detalleItem.id === 0) {
              const response = OrdenCompraService.createPrecio(precioDto)
                .then((r) => {
                  this.loading = false;
                  this.cleanDetalle();
                  this.getAllPrecios();
                  this.snackbar = {
                    show: true,
                    color: "green",
                    text:
                      "Precio " +
                      (!this.detalleItem.id === 0
                        ? "creado "
                        : "actualizado ") +
                      " con éxito.",
                  };
                })
                .catch((r) => {
                  this.loading = false;
                  console.log(r.response);
                  this.snackbar = {
                    show: true,
                    color: "red",
                    text: r.response.data.mensaje,
                  };
                });
            } else {
              const response = OrdenCompraService.updatePrecio(precioDto)
                .then((r) => {
                  this.loading = false;
                  this.cleanDetalle();
                  this.getAllPrecios();
                  this.snackbar = {
                    show: true,
                    color: "green",
                    text:
                      "Precio " +
                      (!this.detalleItem.id === 0
                        ? "creado "
                        : "actualizado ") +
                      " con éxito.",
                  };
                })
                .catch((r) => {
                  this.loading = false;
                  console.log(r.response);
                  this.snackbar = {
                    show: true,
                    color: "red",
                    text: r.response.data.mensaje,
                  };
                });
            }
          }
        });
    },
    cleanDetalle() {
      this.dialogMateriales = false;
      this.detalleItem = Object.assign({}, this.detalleItemDefault);
    },
    async verDetalle(items) {
      this.detalleItem = Object.assign({}, items);

      
      this.isLoading = true;
    
      //determina si ya tiene un producto seleccionado, si es así busca su descripción, se setea en el combobox y luego setea el factor de empaque guardado, si no tiene trae el mas nuevo
      if (this.detalleItem.codigoArticulo != null) {
        const articuloExistente = await OrdenCompraService.getArticuloByCodigo(
          this.detalleItem.codigoArticulo
        ).then(r => {
          this.detalleItem.codigoArticuloIntegracion = r.data;
        });

        
      }

      const response = await OrdenCompraService.findProducto("").then(r => {
        this.productosBusqueda = r.data;

        this.isLoading = false;
       
      });
      this.dialogMateriales = true;
    },
    async createNewMaterial() {
      this.detalleItem = Object.assign({}, this.detalleItemDefault);
       this.isLoading = true;
    
      //determina si ya tiene un producto seleccionado, si es así busca su descripción, se setea en el combobox y luego setea el factor de empaque guardado, si no tiene trae el mas nuevo
      
      const response = await OrdenCompraService.findProducto("").then(r => {
        this.productosBusqueda = r.data;

        this.isLoading = false;
       
      });
      this.dialogMateriales = true;
    },
    async querySelections(v) {
      // Simulated ajax query
      this.isLoading = true;
      const response = await OrdenCompraService.findProducto(v).then((r) => {
        this.productosBusqueda = r.data;

        this.isLoading = false;
      });
    },
  },
  computed: {
    dateFormatedInicio() {
      if (!this.detalleItem.fechaInicio) return null;
      return moment(this.detalleItem.fechaInicio).format(
        "DD-MM-YYYY"
      );
    },
    dateFormatedCajaDesde() {
      if (!this.detalleItem.fechaVigenciaDesde) return null;
      return moment(this.detalleItem.fechaVigenciaDesde).format(
        "YYYY-MM-DD"
      );
    },
    dateFormatedFin() {
      if (!this.detalleItem.fechaFin) return null;
      return moment(this.detalleItem.fechaFin).format(
        "DD-MM-YYYY"
      );
    },
    dateFormatedCajaHasta() {
      if (!this.detalleItem.fechaVigenciaHasta) return null;
      return moment(this.detalleItem.fechaVigenciaHasta).format(
        "YYYY-MM-DD"
      );
    },
  },
  mounted() {},
  watch: {
    searchProductos(val) {
      // Items have already been loaded
      debugger;
      //if (this.detalleItem.codigoProductoIntegracion.length > 0) return
      val && val !== this.select && this.querySelections(val);
    },
    pagination: {
      handler() {
        this.getAllPrecios();
      },
      deep: true,
    },
    dialog: {
      handler: function(val, oldVal) {
        debugger;
        if (!val) {
          setTimeout(function() {}, 500);
        }
      },
      deep: true,
    },
  },
};
</script>
